import $ from 'jquery';

class FullScreenVideo {

  constructor() {
    this.videoImg = $('.video-img');
    this.videoContainer = $('.quotesVideo__video.img');
    this.events();
  }

  events() {
    let vm = this;
    if ($(vm.videoImg).length) {
      $(vm.videoImg).on("click", function () {
        let videoId = $(this).attr('data-video');
        vm.main(videoId);
      });
      $(vm.videoImg).parent().parent().find($(vm.videoContainer)).on("click", function () {
        let videoId = $(this).find($(vm.videoImg)).attr('data-video');
        vm.main(videoId);
      });
    }

  }

  main(videoId) {
    let vm = this;
    if (vm.createModal()) {
      setTimeout(function () {
        vm.createIFrame(videoId);
        vm.openModal();
        //auto play
        $('.video-iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
      }, 300);
    }
  }

  createModal(){
    let modal = $('#fullScreenVideo');
    if(!$(modal).length){
      let modalMarkup = `<div class="modal fade fullScreenVideo" id="fullScreenVideo" tabindex="-1" role="dialog" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div class="modal-content">
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true"><i class="fal fa-times"></i></span>
                              </button>
                              <div class="modal-body">
                              </div>
                            </div>
                          </div>
                        </div>`;

      let footer = document.getElementsByTagName('footer');
      $(modalMarkup).insertBefore(footer);
      setTimeout(function () {
        // On modal close, puse video.
        $('#fullScreenVideo').on('hidden.bs.modal', function (e) {
          $('.video-iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        });
      }, 1000);
    }
    return true;
  }

  createIFrame(videoId) {
    //check if there is an iFrame already matching the same video id, then do nothing;
    if ($('#fullScreenVideo').find('.video-iframe').attr('data-src') === videoId){
      return;
    }
    $('#fullScreenVideo .video-iframe').remove();
    let modalBody = $('#fullScreenVideo').find('.modal-body');
    let iFrame = `<iframe class="video-iframe" width="100%" data-src="` + videoId + `" src="https://www.youtube-nocookie.com/embed/` + videoId + `?rel=0&cc_load_policy=1&hd=1&autoplay=1&enablejsapi=1&vq=hd1080&showinfo=0" frameborder="0" showinfo="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
    $(modalBody).append(iFrame);
  }
  
  openModal(){
    $('#fullScreenVideo').modal('show');
    $('.modal-content .close').on("click", function () {
      console.log('close');
      $('#fullScreenVideo').modal('hide');
    });
  }
}

export default FullScreenVideo;